module.exports = __webpack_public_path__ + "static/media/Test56.041ced26.bmp";